
import Vue from 'vue';
import Analytics from '@/helpers/analytics';
import BreakpointStats from './BreakpointStats.vue';
import { EVENT_LABELS } from '@/helpers/analytics/labels';
import { CourseModel } from '@descomplica/dex-models';
import { ChimeraCourseModel } from '@/models/chimera/ChimeraCourseModel';
import { PostgradTrialStatus } from '@/models/postgradTrial/PostgradTrialModel';

interface OptionInfo {
  label: string;
  numberOfMonths: number;
  isPossible: boolean;
}

export default Vue.extend({
  components: { BreakpointStats },
  props: {
    options: {
      type: Array as Vue.PropType<OptionInfo[]>,
      required: true,
    },
    selectedNumberOfMonths: {
      type: Number,
      required: true,
    },
  },
  computed: {
    currentCourse(): CourseModel {
      return this.$store.getters.currentCourse;
    },
    currentChimeraCourse(): ChimeraCourseModel | null {
      return this.$store.getters.getCurrentChimeraCourse;
    },
    getTrialStatusByDescomplicaCourseId(): PostgradTrialStatus {
      return this.$store.getters.getTrialStatusByDescomplicaCourseId(
        this.currentChimeraCourse?._id,
      );
    },
  },
  mounted() {
    if (this.options.every((o) => o.isPossible === false)) {
      Analytics.trackEvent(EVENT_LABELS.unableToSelectPostgradStudyPlanningOption, {
        course: this.currentCourse.name,
        ...this.getTrialStatusByDescomplicaCourseId,
      });
    }
  },
  methods: {
    selectOption(option: OptionInfo): void {
      this.$emit('optionSelected', option.numberOfMonths);
    },
  },
});
